import SettingsStorage, { MobileOverride } from "./Storage/SettingsStorage";

const PROGRESS_NAMESPACES = ["Story", "Character", "PlayerInventory", "LevelConfig", "Skills"];

class GameSettingsClass {
  public debugMode: boolean;
  public mobileOverride: MobileOverride;

  private mStorage: SettingsStorage;

  constructor() {
    this.mStorage = new SettingsStorage();
    this.debugMode = this.mStorage.GetDebugMode();
    this.mobileOverride = this.mStorage.GetMobileOverride();
  }

  public SetDebugMode(val: boolean): void {
    this.debugMode = val;
    this.mStorage.SetDebugMode(val);
  }

  public SetMobileOverride(val: MobileOverride): void {
    this.mobileOverride = val;
    this.mStorage.SetMobileOverride(val);
  }

  public ResetProgress(): void {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && PROGRESS_NAMESPACES.some(ns => key.startsWith(`${ns}:`))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }
}

const GameSettings = new GameSettingsClass();
export default GameSettings;
